import { render } from "./PurchaseTableStockman.vue?vue&type=template&id=8273a28a"
import script from "./PurchaseTableStockman.vue?vue&type=script&lang=js"
export * from "./PurchaseTableStockman.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__